<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('select_table') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0 px-3">
        <div class="list_layout pb-2">
          <div class="list_layout-conteiner">
            <template v-for="(item, idx) in list_restolayout">
              <v-chip
                :key="idx"
                small
                :outlined="selected[idx] === true ? false : true"
                :color="selected[idx] === true ? 'primary' : 'grey'"
                :class="[`mr-2 px-2 line-height-regular`, { 'ml-3': idx === 0, 'mr-3': idx === list_restolayout.length - 1 }]"
                @click="loadRestoLayoutDetail(item.id, idx)"
              >
                {{ item.name }}
              </v-chip>
            </template>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="list-table">
          <div class="list-table-conteiner">
            <div class="">
              <template v-for="(n, idx) in l_rows">
                <div :key="idx" class="ols-row">
                  <template v-for="(x, index) in l_cols">
                    <div
                      :key="index"
                      :class="[
                        `ols-table`,
                        { 'is_table': restolayout.items.findIndex(x => x.col === index && x.row === idx) === -1 ? false : true },
                        { 'is_blocked': data_table[idx][index].is_blocked === 1 ? true : false },
                        { 'primary white--text': data_table[idx][index].selected === true }
                      ]"
                      @click="selectTable(data_table[idx][index])"
                    >
                      {{ data_table[idx][index].name }}
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <div class="__menu-bottom menu-full">
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
          <v-btn color="primary" block x-large class="text-none" :disabled="disabled" @click="setTable()">
            {{ $t('next') }}
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import {
  getDataTable as getDataTableDinein,
  getDataDetailTable as getDataDetailTableDinein
} from '@/api/setting'
export default {
  data() {
    return {
      selected: [true],
      form: {
        total_guest: 1,
        table: '',
        table_detail: {},
        item: []
      },
      l_rows: 0,
      l_cols: 0,
      data_table: [],
      restolayout: {},
      list_restolayout: [],
      disabled: true
    }
  },
  created() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))) this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN'))
    this.loadRestoLayout()
  },
  methods: {
    async loadRestoLayout() {
      try {
        const { data } = await getDataTableDinein()
        this.$store.state.loading_axios = false
        this.list_restolayout = data.data
        this.loadRestoLayoutDetail(this.list_restolayout[0].id, 0, this.list_restolayout[0].name)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async loadRestoLayoutDetail(id, idx = 0, name = null) {
      try {
        let params = {}
        if (name) {
          params = {
            table_name: name
          }
        }
        const { data } = await getDataDetailTableDinein(id, params)
        this.selected = []
        this.selected[idx] = true
        this.restolayout = {}
        this.$store.state.loading_axios = false
        this.restolayout = data.data
        this.l_rows = Number(this.restolayout.rows)
        this.l_cols = Number(this.restolayout.cols)
        this.data_table = []
        for (var i = 0; i < this.l_rows; i++) {
          this.data_table.push([])
          for (var n = 0; n < this.l_cols; n++) {
            const index = this.restolayout.items.findIndex(x => x.col === n && x.row === i)
            if (index !== -1) {
              this.data_table[i].push({
                index: index,
                id: this.restolayout.items[index].id,
                name: this.restolayout.items[index].name,
                is_blocked: this.restolayout.items[index].is_blocked,
                selected: false
              })
            } else {
              this.data_table[i].push({
                index: index,
                id: null,
                name: '',
                is_blocked: 0,
                selected: false
              })
            }
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async totalGuest() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.$store.dispatch('saveDataCartDineIn', this.form)
        this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
      }
    },
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    selectTable(item) {
      if (!this.$isEmpty(item)) {
        var data_x = {}
        for (var i = 0; i < this.data_table.length; i++) {
          this.data_table[i].map(x => {
            if (x.selected === true) {
              x.selected = false
            }
          })
          const index_selected = this.data_table[i].findIndex(x => x.id === item.id)
          data_x = { ...this.data_table[i][index_selected] }
          if (index_selected !== -1) {
            if (data_x.selected === true) {
              this.$set(this.data_table[i], index_selected, {
                index: data_x.index,
                id: data_x.id,
                name: data_x.name,
                is_blocked: data_x.is_blocked,
                selected: false
              })
            } else {
              this.$set(this.data_table[i], index_selected, {
                index: data_x.index,
                id: data_x.id,
                name: data_x.name,
                is_blocked: data_x.is_blocked,
                selected: true
              })
            }
          }
        }
        this.form.table = item.id
        this.form.table_detail = item
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    setTable() {
      this.$store.dispatch('saveDataCartDineIn', this.form)
      this.$router.push({ name: 'total_guest_dinein' }).catch(() => {})
    }
  }
}
</script>
